<div class="fr-page">

  <!-- Section header: mirrors the Tasks tab so the record tabs read as one surface -->
  <div class="fr-head">
    <div class="fr-head__text">
      <span class="fr-eyebrow">Resident work</span>
      <h2 class="fr-title">Form Reports</h2>
      <p class="fr-sub">Submitted form data, grouped by the folder each form lives in.</p>
    </div>

    <div class="fr-head__meta" *ngIf="statFolderCount > 0">
      <span class="fr-chip">{{ statFolderCount }} {{ statFolderCount === 1 ? 'folder' : 'folders' }}</span>
      <span class="fr-chip fr-chip--count">{{ statFormCount }} {{ statFormCount === 1 ? 'form' : 'forms' }}</span>
    </div>
  </div>

  <div class="documentBox">

    <div Id="document" class="documents" [ngClass]="{ list: true, grid: false }">
      <mat-accordion [multi]="true">

        <ng-container *ngFor="let folder of FormFolderReportList; let i = index">

          <mat-expansion-panel class="fr-folder" [expanded]="step === i" disabled="false" (click)="togglePanels(i)">
            <mat-expansion-panel-header>
              <mat-panel-title class="header">
                <div class="titleCount">
                  <span class="fr-folder__icon"><mat-icon>folder</mat-icon></span>

                  <div class="folderName">
                    {{ folder.folderName }}
                    <span class="count">{{ folder.forms.length }}</span>
                  </div>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="documentcontainer">

              <div class="categories">

                <ul>

                  <li *ngFor="let document of folder.forms; let j = index">
                    <div class="documentList">

                      <span class="reportName">
                        <mat-icon class="fr-form__glyph">description</mat-icon>
                        {{ document.formName }}

                        <button mat-icon-button class="fr-info" matTooltip="Form details" matTooltipClass="tooltip"
                          (click)="openHtmlData(document)">
                          <mat-icon>info</mat-icon>
                        </button>
                      </span>

                      <div class="fr-tablewrap" *ngIf="!noRecordFound">
                        <table class="table">
                          <span *ngFor="let row of document.datatable; let i = index">
                            <thead>
                              <th class="col">{{ row.columnName }}</th>
                            </thead>

                            <tr *ngFor="let rowdata of row.value; let j = index">
                              <td>
                                <!-- If column is "Submited By", show Preview button -->
                                <ng-container *ngIf="row.columnName === 'Submitted By'; else normalCell">
                                  <span class="submittedByCell">
                                    <mat-icon *ngIf="rowdata !== '-'" color="primary" style="cursor: pointer;"
                                      matTooltip="Preview" (click)="viewHTMLData(rowdata, j,folder,document)">
                                      visibility
                                    </mat-icon>
                                    {{ rowdata }}
                                  </span>
                                </ng-container>

                                <!-- Normal cell display for other columns -->
                                <ng-template #normalCell>
                                  <ng-container *ngIf="row.type == 'Signature'; else elseifInitials">
                                    <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px" src="{{ rowdata }}" />
                                    <p *ngIf="rowdata == '-'">-</p>
                                    <p *ngIf="rowdata.substring(0,5) != 'data:' && rowdata != '-'">{{ rowdata }}</p>
                                  </ng-container>

                                  <ng-template #elseifInitials>
                                    <ng-container *ngIf="row.type == 'Initials'; else elseifImage">
                                      <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px"
                                        src="{{ rowdata }}" />
                                      <p *ngIf="rowdata == '-'">-</p>
                                      <p *ngIf="rowdata.substring(0,5) != 'data:' && rowdata != '-'">{{ rowdata }}</p>
                                    </ng-container>
                                  </ng-template>

                                  <ng-template #elseifImage>
                                    <ng-container *ngIf="row.type == 'Image'; else elseifFile">
                                      <img *ngIf="rowdata.substring(0,5) == 'data:'" height="32px"
                                        src="{{ rowdata }}" />
                                      <p *ngIf="rowdata == '-'">-</p>
                                    </ng-container>
                                  </ng-template>

                                  <ng-template #elseifFile>
                                    <ng-container *ngIf="row.type == 'File'; else elseRow">
                                      <p class="fr-download" *ngIf="rowdata.substring(0,5) == 'data:'"
                                        (click)="DownloadFile(rowdata, row)">Download</p>
                                      <p *ngIf="rowdata == '-'">-</p>
                                    </ng-container>
                                  </ng-template>

                                  <ng-template #elseRow>
                                    <p>{{ rowdata }}</p>
                                  </ng-template>
                                </ng-template>
                              </td>
                            </tr>
                          </span>
                        </table>
                      </div>

                    </div>
                  </li>

                  <li class="fr-empty fr-empty--forms" *ngIf="folder.forms.length === 0">
                    No forms in this folder yet.
                  </li>

                </ul>
              </div>
            </div>

          </mat-expansion-panel>

        </ng-container>

      </mat-accordion>
    </div>

    <div class="fr-empty" *ngIf="statFolderCount === 0">
      <mat-icon>description</mat-icon>
      <p>No form reports for this record yet.</p>
    </div>

  </div>

</div>


<!-- <app-htmlReportData3c (getCloseHtmlData)="getCloseHtmlData($event)" [ngClass]="{ open: htmlData }" >
</app-htmlReportData3c> -->
